import type { OTCDealData } from '@src/types/OTC';
import type { Security } from '@talos/kyoko';

type DealPropertyName = 'deal' | 'loan' | 'repo';

export type DealJsonObject<T extends DealPropertyName> = Record<T, OTCDealData> & { security: Security | undefined };

interface DealJsonObjectParams<T extends DealPropertyName> {
  deal: OTCDealData;
  propertyName: T;
  securitiesBySymbol: Map<string, Security>;
}

interface CreateDealJsonObjectParams<T extends DealPropertyName> {
  deal: OTCDealData | undefined;
  propertyName: T;
  securitiesBySymbol: Map<string, Security>;
  handleClickJson: (jsonObject: DealJsonObject<T>) => void;
}

export function getDealJsonObject<T extends DealPropertyName>({
  deal,
  propertyName,
  securitiesBySymbol,
}: DealJsonObjectParams<T>): DealJsonObject<T> {
  const security = deal.Symbol ? securitiesBySymbol.get(deal.Symbol) : undefined;
  return {
    [propertyName]: deal,
    security,
  } as DealJsonObject<T>;
}

/**
 * Creates a custom JSON object with deal/loan and security information for display in JSON modal.
 */
export function createDealJsonObject<T extends DealPropertyName>({
  deal,
  propertyName,
  securitiesBySymbol,
  handleClickJson,
}: CreateDealJsonObjectParams<T>): void {
  if (!deal) {
    return;
  }
  handleClickJson(getDealJsonObject({ deal, propertyName, securitiesBySymbol }));
}
